import { render } from "./TeamReportResultTeam1Page.vue?vue&type=template&id=16032920&scoped=true"
import script from "./TeamReportResultTeam1Page.vue?vue&type=script&lang=js"
export * from "./TeamReportResultTeam1Page.vue?vue&type=script&lang=js"

import "./TeamReportResultTeam1Page.vue?vue&type=style&index=0&id=16032920&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16032920"]])

export default __exports__